import React from "react";
import { gettext } from "web/script/modules/django-i18n";
import SendToApp, { SendToAppProps } from "web/react/components/send-to-app/send-to-app";
import ContinueToOption from "web/react/components/continue-to-option/continue-to-option";

interface SendToAppWithTrackedLinkProps extends SendToAppProps {
    leadUrl: string;
    productId: string;
    reason: string;
}

export default function SendToAppWithTrackedLink({
    title,
    analyticsEventLabel,
    url,
    productImageURL,
    appDeepLinkURL,
    className,
    leadUrl,
    productId,
    reason,
    financialIncentiveWebviewToken,
    downloadCTA,
}: SendToAppWithTrackedLinkProps): JSX.Element {
    downloadCTA = downloadCTA ? downloadCTA : gettext("app_download_large_banner.general.cta");
    return (
        <SendToApp
            title={title}
            analyticsEventLabel={analyticsEventLabel}
            url={url}
            productImageURL={productImageURL}
            downloadCTA={downloadCTA}
            className={className}
            appDeepLinkURL={appDeepLinkURL}
            financialIncentiveWebviewToken={financialIncentiveWebviewToken}
            extraContent={(): JSX.Element => {
                return (
                    <ContinueToOption
                        href={leadUrl}
                        continueMessage={gettext("general.continue_to_retailer.link")}
                        analyticsEventLabel={analyticsEventLabel}
                        isTrackedLink={true}
                        reason={reason}
                        productId={productId}
                    />
                );
            }}
        />
    );
}
